
import Vue from "vue";
import { PropType } from "vue";
import { tapestryMixins } from "@/mixins/tapestryMixins";
import {
  TapestryCampaign,
  TapestryCivilization,
  TapestryPlay,
  TapestryScenario,
} from "@/types";

export default Vue.extend({
  name: "TapestryScoresByScenario",
  mixins: [tapestryMixins],
  props: {
    civilizations: {
      type: Array as PropType<TapestryCivilization[]>,
      required: true,
      default: [],
    },
    campaigns: {
      type: Array as PropType<TapestryCampaign[]>,
      required: true,
      default: [],
    },
    scenarios: {
      type: Array as PropType<TapestryScenario[]>,
      required: true,
      default: [],
    },
    plays: {
      type: Array as PropType<TapestryPlay[]>,
      required: true,
      default: [],
    },
    mainPlayerId: {
      type: Number,
      default: 1,
    },
  },
});
